import { render } from "./hours.vue?vue&type=template&id=672aabbf&scoped=true"
import script from "./hours.vue?vue&type=script&lang=js"
export * from "./hours.vue?vue&type=script&lang=js"

import "./hours.vue?vue&type=style&index=0&id=672aabbf&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672aabbf"]])

export default __exports__